import { useEffect, useState } from "react";
import { API_GET } from "../API/config";
import { API_endpoints } from "../API/API_Endpoints";

const useDietList = () => {
    const [dietList, setdietList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchList = async () => {
        try
        {
            let res = await API_GET(API_endpoints.getdietcat);
            if (res?.s)
            {
                setdietList(res?.r);
            } else
            {
                // throw new Error("Failed to fetch data");
                console.log(error)
            }
        } catch (error)
        {
            setError(error.message);
            console.log(error)
        } finally
        {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchList();
    }, []);

    return { dietList, loading, error };
};

export default useDietList;
